export const svgs = [
  'x',
  'trash',
  'sustainability',
  'search',
  'rotate-ccw',
  'rcm-logo2',
  'rcm-logo1',
  'rcm-logo',
  'rcm-logo-rsi2',
  'rcm-logo-rsi',
  'printer',
  'play',
  'phone',
  'pause',
  'message-circle',
  'menu',
  'map-pin',
  'mail',
  'lock',
  'linkedin',
  'link',
  'info',
  'inbox',
  'help-circle',
  'fund-sustainable',
  'flag-sk',
  'flag-si',
  'flag-ro',
  'flag-pl',
  'flag-nl',
  'flag-lu',
  'flag-li',
  'flag-it',
  'flag-hu',
  'flag-hr',
  'flag-fr',
  'flag-es',
  'flag-de',
  'flag-cz',
  'flag-ch',
  'flag-bg',
  'flag-be',
  'flag-at',
  'filter',
  'filter-or-sort',
  'facebook',
  'external-link',
  'download',
  'download-file',
  'download-file-arrow',
  'copy',
  'clock',
  'clear',
  'circle',
  'chevron-up',
  'chevron-right',
  'chevron-left',
  'chevron-down',
  'check',
  'camera',
  'calendar',
  'calendar-add',
  'arrow-right',
  'arrow-left',
  'alert-triangle',
  'alert-circle',
] as const;
